import { useAuthStore } from '../store/authStore';
/**
 * Reads the auth store and returns a stable shape for role gating.
 *
 * Note: `isWholesaler` is true for any user with role=wholesaler, approved or not.
 * Pricing / cart gating checks approval status via the server (GetMe.isApproved)
 * — don't trust the store alone for money decisions.
 */ export function useCurrentUser() {
    const { isAuthenticated, isAdmin, role, userID, username, email } = useAuthStore();
    return {
        isAuthenticated,
        isAdmin,
        isWholesaler: role === 'wholesaler',
        userID,
        username,
        email,
        role
    };
}
